import { getPrintFileJobs } from '../../thunk/printFileJobs';

const extraReducers = {
    [getPrintFileJobs.pending as any]: (state: any) => {
        state.status = 'loading';
        state.error = null;
    },
    [getPrintFileJobs.fulfilled as any]: (state: any, action: any) => {
        state.status = 'resolved';
        state.list = action.payload.result || [];
        state.queryParams = {
            ...action.meta.arg,
            page: +action.payload.page,
            limit: +action.payload.perPage,
            total: +action.payload.totalCount,
        };
    },
    [getPrintFileJobs.rejected as any]: (state: any, action: any) => {
        state.status = 'rejected';
        state.error = action.payload;
    },
};

export default extraReducers;
